import { Link } from "react-router-dom";
import { MapTrifold, MagicWand } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import AreasStep from "@/components/rentincrease/AreasStep";

export default function Vergleichsmieten() {
  return (
    <div className="space-y-5" data-testid="vergleichsmieten-page">
      <div className="flex flex-wrap items-end gap-3">
        <div>
          <h1 className="text-2xl font-semibold text-slate-900 flex items-center gap-2"><MapTrifold size={24} /> Vergleichsmieten je Stadt/Stadtteil</h1>
          <p className="text-sm text-slate-500">Ortsübliche Vergleichsmieten und Kappungsgrenzen Ihres Bestands – maßgeblich für Mieterhöhungs-Prüfung und Assistent (§ 558 BGB).</p>
        </div>
        <Link to="/mieterhoehungen/assistent" className="ml-auto"><Button size="sm" className="gap-1" data-testid="vm-wizard-btn"><MagicWand size={14} /> Assistent starten</Button></Link>
      </div>
      <AreasStep />
    </div>
  );
}
